import { ErrorState } from './../../redux/AppReducer';
import { AppActions } from '../../redux/AppActions';
import { useEffect, useCallback } from 'react';
import { useAppDispatch } from '../../redux/store';
import imageServerError from '../../assets/images/ErrorState404.png';
export const GeneralError = () => {
	const dispatch = useAppDispatch();

	const errorCallback = useCallback(
		(errorDetail: ErrorState) => {
			dispatch(AppActions.setGeneralError(errorDetail));
		},
		[dispatch]
	);

	useEffect(() => {
		const error = {
			hasError: true,
			errorTitle: '',
			errorContent: 'The page you are looking for could not be found.',
			errorSubContent: 'Please try again.',
			errorImg: imageServerError
		};
		errorCallback(error);
	}, []);
	return null;
};
